import React from 'react'
import Sidebar from './Sidebar'

function Header(){
    return (
        < div style={{height:'50px',backgroundColor:'#56636A',display:'flex',alignItems:'center',marginBottom:'10px'}}>
         <div style={{fontFamily:'Arvo',color:'white',marginLeft:'20px'}}>
            SB Pathshala Dashboard
         </div>
        </div>
    )
}

export default Header